import {
  Box,
  FormControl,
  Text,
  RadioGroup,
  Radio,
  Collapse,
} from '@chakra-ui/react';
import { useAppSelector, useAppDispatch } from '../../../store/redux/hooks';
import { setFieldProp } from '../../../store/redux/slices/template.slice';
import { RADIO_GROUP_SX } from './utils/radioGroupStyles';

interface OverrideFieldValueRadioProps {
  section: string;
  slot: string;
  isVisible: boolean;
  value: 'new' | 'all';
  onChange: (value: 'new' | 'all') => void;
}

const OverrideFieldValueRadio = ({
  section,
  slot,
  isVisible,
  value,
  onChange,
}: OverrideFieldValueRadioProps) => {
  const dispatch = useAppDispatch();
  const passesCount = useAppSelector((s) => s.template._passesCount);

  return (
    <Collapse in={isVisible && passesCount > 0}>
      <Box mt={4} ml={2} borderRadius="8px" p={2}>
        <FormControl isRequired>
          <Text fontSize="14px" fontFamily="Inter Regular, sans-serif" mb={2}>
            Who should this change apply to?
            <Text as="span" color="red">
              *
            </Text>
          </Text>
          <RadioGroup
            value={value}
            onChange={(val: 'new' | 'all') => {
              onChange(val);
              dispatch(
                setFieldProp({
                  section,
                  slot,
                  key: 'overrideFieldValue',
                  value: val === 'all',
                })
              );
            }}
            display="flex"
            flexDirection="column"
            gap={2}
            mt={4}
            sx={RADIO_GROUP_SX}
          >
            <Radio value="new">
              <Text fontSize="12px">New passes only</Text>
            </Radio>
            <Radio value="all">
              <Text fontSize="12px">
                New and existing {passesCount.toLocaleString()}{' '}
                {passesCount === 1 ? 'pass' : 'passes'}
              </Text>
            </Radio>
          </RadioGroup>
        </FormControl>
      </Box>
    </Collapse>
  );
};

export default OverrideFieldValueRadio;
